import axios from '@axios'

const PREFIX = 'portal-documentos'

export default {

  getPaginado(page, pageSize, filtros, filtroString, idFiltroCustom) {
    return axios.post(`${PREFIX}/paged?pagina=${page}&tamanhoPagina=${pageSize}&multiFiltro=${filtroString}&idFiltroCustom=${idFiltroCustom}`, filtros)
  },

  baixaEmLote(nome, filtroDocs) {
    return axios.post(`${PREFIX}/baixa-lote?nomeArquivo=${nome}`, filtroDocs)
  },

  enviarEmLote(nome, filtroDocs) {
    return axios.post(`${PREFIX}/enviar-email?nomeArquivo=${nome}`, filtroDocs)
  },

  salvarEmail(empresaId, email) {
    return axios.post(`${PREFIX}/email?id=${empresaId}&email=${email}`)
  },

  getObservacoes(id) {
    return axios.get(`${PREFIX}/${id}/observacao`)
  },

  removerObservacao(id) {
    return axios.delete(`${PREFIX}/observacao/${id}/remover`)
  },

  salvarObservacao(observacao) {
    return axios.post(`${PREFIX}/observacao/salvar`, observacao)
  },

  getTodasLinhas(filtros, filtroString, filtroCustomId) {
    return axios.post(`${PREFIX}/allPaged?multiFiltro=${filtroString}&filtroCustomId=${filtroCustomId}`, filtros)
  },

  getDocWhatsapp(id, docs) {
    return axios.get(`${PREFIX}/${id}/url-whatsapp?docs=${docs}`)
  },
}
